import {
  EyeIcon,
} from "@heroicons/react/outline";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";

import { useEffect, useState } from "react";

const Gallery = ({ data }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const handleRightClick = (e) => {
    e.preventDefault();
    setShowWarning(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!selectedImage) return;

      if (event.key === "ArrowLeft") {
        navigateImage(-1);
      } else if (event.key === "ArrowRight") {
        navigateImage(1);
      } else if (event.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedImage]);


  const openModal = (imageData, timeFrame, sectionImages , sectionId) => {
    const largeImageUrl = `/images/stillImages/original/${String(
      imageData.id
    ).padStart(2, "0")}.jpg`;
    setSelectedImage({
      ...imageData,
      url: largeImageUrl,
      timeFrame: timeFrame,
      sectionId: sectionId,
      sectionImages: sectionImages,
    });
    setIsLoading(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsLoading(false);
  };

  const handleImageLoad = () => {
    setIsLoading(false);
  };
  const navigateImage = (direction) => {
    const currentSectionIndex = data.findIndex(
      (section) => section.sectionId === selectedImage.sectionId
    );
    const currentImageIndex = selectedImage.sectionImages.findIndex(
      (image) => image.id === selectedImage.id
    );
    
    let newIndex = currentImageIndex + direction;
    console.log(currentSectionIndex, currentImageIndex ,newIndex, selectedImage.sectionImages.length);

    if (newIndex >= selectedImage.sectionImages.length) {
      if (currentSectionIndex < data.length - 1) {
        const nextSection = data[currentSectionIndex + 1];
        setSelectedImage({
          ...nextSection.image[0],
          url: `/images/stillImages/original/${String(
            nextSection.image[0].id
          ).padStart(2, "0")}.jpg`,
          timeFrame: nextSection.timeFrame,
          sectionId: nextSection.sectionId,
          sectionImages: nextSection.image,
        });
      } else {
        const firstSection = data[0];
        setSelectedImage({
          ...firstSection.image[0],
          url: `/images/stillImages/original/${String(
            firstSection.image[0].id
          ).padStart(2, "0")}.jpg`,
          timeFrame: firstSection.timeFrame,
          sectionId: firstSection.sectionId,
          sectionImages: firstSection.image,
        });
      }
    } else if (newIndex < 0) {
      // If at the first image of the current section, move to the last image of the previous section
      if (currentSectionIndex > 0) {
        const prevSection = data[currentSectionIndex - 1];
        const lastImage = prevSection.image[prevSection.image.length - 1];
        setSelectedImage({
          ...lastImage, // Last image of the previous section
          url: `/images/stillImages/original/${String(lastImage.id).padStart(
            2,
            "0"
          )}.jpg`,
          timeFrame: prevSection.timeFrame,
          sectionId: prevSection.sectionId,
          sectionImages: prevSection.image,
        });
      } else {
        // If at the first section, loop back to the last image of the last section
        const lastSection = data[data.length - 1];
        const lastImage = lastSection.image[lastSection.image.length - 1];
        setSelectedImage({
          ...lastImage,
          url: `/images/stillImages/original/${String(lastImage.id).padStart(
            2,
            "0"
          )}.jpg`,
          timeFrame: lastSection.timeFrame,
          sectionId: lastSection.sectionId,
          sectionImages: lastSection.image,
        });
      }
    } else {
      // Move within the same section
      const nextImage = selectedImage.sectionImages[newIndex];
      setSelectedImage({
        ...nextImage,
        url: `/images/stillImages/original/${String(nextImage.id).padStart(
          2,
          "0"
        )}.jpg`,
        timeFrame: selectedImage.timeFrame,
        sectionId: selectedImage.sectionId,
        sectionImages: selectedImage.sectionImages,
      });
    }
  
    setIsLoading(true);
  };
  
  
  return (
    <div className="px-6">
      {data.map((section) => (
        <>
          <h2 className="text-md lg:text-lg mt-2 font-extralight h-10 sticky top-0 z-10 bg-white">
            {section?.timeFrame}
          </h2>
          <div className="grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 grid-cols-2 gap-8">
            {section.image.map((item) => (
              <div key={item.id} className="relative group text-center">
                <img
                  src={`/images/stillImages/thumbnail/${String(
                    item.id
                  ).padStart(2, "0")}.jpg`}
                  alt={item.title}
                  className="w-full h-auto rounded-md border border-gray-300 cursor-pointer"
                />
                <div
                  onClick={() =>
                    openModal(item, section?.timeFrame, section.image, section?.sectionId)
                  }
                  className="absolute cursor-pointer inset-0 flex items-center justify-center bg-black bg-opacity-65 opacity-0 group-hover:opacity-100 rounded-md">
                  <p className="text-white font-extralight text-lg flex items-center gap-1">
                    <EyeIcon className="h-5 w-5" /> <span>View</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      ))}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          onClick={closeModal}>
            
          <div
            className="relative bg-white max-w-full max-h-[99vh] lg:overflow-hidden md:overflow-y-auto overflow-y-auto"
            onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute top-0 right-0 text-[10px] m-2 bg-gray-200 hover:bg-red-500 w-6 h-6 rounded-full text-gray-500 hover:text-white"
              onClick={closeModal}>
              ✕
            </button>
            <div className="flex flex-col justify-center items-center overflow-hidden p-10 pb-0">
              {isLoading && (
                <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-50">
                  <div className="w-16 h-16 border-t-4 border-b-4 border-white rounded-full animate-spin"></div>
                </div>
              )}
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-[90vw] max-h-[70vh] object-contain"
                onContextMenu={(e) => {
                  handleRightClick(e);
                }}
                onLoad={handleImageLoad}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              {showWarning && (
                <div
                  className="bg-gray-700"
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    padding: "6px 15px",
                    zIndex: 1000,
                    fontSize: "10px",
                  }}>
                  <div className="flex justify-between mb-3">
                    <h3 className="font-bold text-md">WARNING</h3>
                    <button
                      onClick={() => setShowWarning(false)}
                      style={{
                        marginLeft: "10px",
                        color: "white",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bolder",
                      }}>
                      X
                    </button>
                  </div>
                  <span>
                    All content is protected by copyright and may not be <br />{" "}
                    downloaded or copied.
                  </span>
                </div>
              )}
              <div className="text-center mx-5  flex flex-col justify-center items-center mt-3">
                <h2 className="text-md font-bold mb-2">
                  {selectedImage.title}
                </h2>
                <p className="text-[13px] text-gray-600 mb-[2px] whitespace-pre-line">
                  {selectedImage.description}
                </p>
                <p className="text-[13px] text-gray-600 mb-[2px]">
                  {selectedImage.timeFrame}
                </p>
                <p className="text-[13px] text-gray-600">
                  {selectedImage.status}
                </p>
              </div>
            </div>
            <div className="flex z-10 justify-end p-4 pt-0">
                <button
                  onClick={() => navigateImage(-1)}
                  className="flex items-center p-1 rounded-full"
                >
                  <ChevronLeftIcon className="h-4 w-4" />
                </button>

                <button
                  onClick={() => navigateImage(1)}
                  className="flex items-center p-1 rounded-full font-bold"
                >
                  <ChevronRightIcon className="h-4 w-4" />
                </button>
              </div>
            
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
